import { get, patch, post, remove } from 'vio-libs';
export function getRoles(organization, consumerAPI = false) {
    if (!consumerAPI) {
        return get(`roles?organization=${organization}`);
    }
    return get(`v1/${organization}/roles?expand=permissions`, undefined, true);
}
export function postNewRole(organization, role, consumerAPI = false) {
    if (!consumerAPI) {
        return post(`roles?organization=${organization}`, {
            data: Object.assign({}, role)
        });
    }
    return post(`v1/${organization}/roles`, {
        data: Object.assign({}, role)
    }, true);
}
export function patchExistingRole(organization, roleId, update, consumerAPI = false) {
    if (!consumerAPI) {
        return patch(`roles?organization=${organization}`, {
            data: {
                role_id: roleId,
                update
            }
        });
    }
    return patch(`v1/${organization}/roles/${roleId}`, {
        data: Object.assign({}, update)
    }, true);
}
export function removeRole(organization, roleId, consumerAPI = false) {
    if (!consumerAPI) {
        return remove(`roles?organization=${organization}`, {
            data: {
                role_id: roleId
            }
        });
    }
    return remove(`v1/${organization}/roles/${roleId}`, undefined, true);
}
